import './App.css';
import SongsList from './components/SongList';
import Player from './components/Player';
import Header from './components/Header';
import React from 'react';
class App extends React.Component{

  state={
    data:[
        
            {
                "id": 1169503732,
                "readable": true,
                "title": "Punjab Bolda",
                "title_short": "Punjab Bolda",
                "title_version": "",
                "link": "https://www.deezer.com/track/1169503732",
                "duration": 307,
                "rank": 188438,
                "explicit_lyrics": false,
                "explicit_content_lyrics": 0,
                "explicit_content_cover": 2,
                "preview": "https://cdns-preview-b.dzcdn.net/stream/c-b97797b8dc16071624a7df43d77785ef-2.mp3",
                "md5_image": "d59978e39d94332890c6fa7f1fa8966f",
                "artist": {
                    "id": 5368678,
                    "name": "Ranjit Bawa",
                    "link": "https://www.deezer.com/artist/5368678",
                    "picture": "https://api.deezer.com/artist/5368678/image",
                    "picture_small": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/56x56-000000-80-0-0.jpg",
                    "picture_medium": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/250x250-000000-80-0-0.jpg",
                    "picture_big": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/500x500-000000-80-0-0.jpg",
                    "picture_xl": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/1000x1000-000000-80-0-0.jpg",
                    "tracklist": "https://api.deezer.com/artist/5368678/top?limit=50",
                    "type": "artist"
                },
                "album": {
                    "id": 191743462,
                    "title": "Punjab Bolda",
                    "cover": "https://api.deezer.com/album/191743462/image",
                    "cover_small": "https://cdns-images.dzcdn.net/images/cover/d59978e39d94332890c6fa7f1fa8966f/56x56-000000-80-0-0.jpg",
                    "cover_medium": "https://cdns-images.dzcdn.net/images/cover/d59978e39d94332890c6fa7f1fa8966f/250x250-000000-80-0-0.jpg",
                    "cover_big": "https://cdns-images.dzcdn.net/images/cover/d59978e39d94332890c6fa7f1fa8966f/500x500-000000-80-0-0.jpg",
                    "cover_xl": "https://cdns-images.dzcdn.net/images/cover/d59978e39d94332890c6fa7f1fa8966f/1000x1000-000000-80-0-0.jpg",
                    "md5_image": "d59978e39d94332890c6fa7f1fa8966f",
                    "tracklist": "https://api.deezer.com/album/191743462/tracks",
                    "type": "album"
                },
                "type": "track"
            },
            {
                "id": 534859312,
                "readable": true,
                "title": "Tankha",
                "title_short": "Tankha",
                "title_version": "",
                "link": "https://www.deezer.com/track/534859312",
                "duration": 178,
                "rank": 197328,
                "explicit_lyrics": false,
                "explicit_content_lyrics": 0,
                "explicit_content_cover": 2,
                "preview": "https://cdns-preview-4.dzcdn.net/stream/c-49318953ec99a81a4eb458067bc2f0d4-3.mp3",
                "md5_image": "8a33300a50c2a18f2dd06c5b79699deb",
                "artist": {
                    "id": 5368678,
                    "name": "Ranjit Bawa",
                    "link": "https://www.deezer.com/artist/5368678",
                    "picture": "https://api.deezer.com/artist/5368678/image",
                    "picture_small": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/56x56-000000-80-0-0.jpg",
                    "picture_medium": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/250x250-000000-80-0-0.jpg",
                    "picture_big": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/500x500-000000-80-0-0.jpg",
                    "picture_xl": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/1000x1000-000000-80-0-0.jpg",
                    "tracklist": "https://api.deezer.com/artist/5368678/top?limit=50",
                    "type": "artist"
                },
                "album": {
                    "id": 69550082,
                    "title": "Tankha - Single",
                    "cover": "https://api.deezer.com/album/69550082/image",
                    "cover_small": "https://cdns-images.dzcdn.net/images/cover/8a33300a50c2a18f2dd06c5b79699deb/56x56-000000-80-0-0.jpg",
                    "cover_medium": "https://cdns-images.dzcdn.net/images/cover/8a33300a50c2a18f2dd06c5b79699deb/250x250-000000-80-0-0.jpg",
                    "cover_big": "https://cdns-images.dzcdn.net/images/cover/8a33300a50c2a18f2dd06c5b79699deb/500x500-000000-80-0-0.jpg",
                    "cover_xl": "https://cdns-images.dzcdn.net/images/cover/8a33300a50c2a18f2dd06c5b79699deb/1000x1000-000000-80-0-0.jpg",
                    "md5_image": "8a33300a50c2a18f2dd06c5b79699deb",
                    "tracklist": "https://api.deezer.com/album/69550082/tracks",
                    "type": "album"
                },
                "type": "track"
            },
            {
                "id": 1099145262,
                "readable": true,
                "title": "Kinne Aye Kinne Gye",
                "title_short": "Kinne Aye Kinne Gye",
                "title_version": "",
                "link": "https://www.deezer.com/track/1099145262",
                "duration": 416,
                "rank": 110052,
                "explicit_lyrics": false,
                "explicit_content_lyrics": 0,
                "explicit_content_cover": 2,
                "preview": "https://cdns-preview-9.dzcdn.net/stream/c-92dafba2f468fe4c76b3cc597aa0d562-3.mp3",
                "md5_image": "bf45f20545c62de6f906df3b52e10508",
                "artist": {
                    "id": 5368678,
                    "name": "Ranjit Bawa",
                    "link": "https://www.deezer.com/artist/5368678",
                    "picture": "https://api.deezer.com/artist/5368678/image",
                    "picture_small": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/56x56-000000-80-0-0.jpg",
                    "picture_medium": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/250x250-000000-80-0-0.jpg",
                    "picture_big": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/500x500-000000-80-0-0.jpg",
                    "picture_xl": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/1000x1000-000000-80-0-0.jpg",
                    "tracklist": "https://api.deezer.com/artist/5368678/top?limit=50",
                    "type": "artist"
                },
                "album": {
                    "id": 177475252,
                    "title": "Kinne Aye Kinne Gye",
                    "cover": "https://api.deezer.com/album/177475252/image",
                    "cover_small": "https://cdns-images.dzcdn.net/images/cover/bf45f20545c62de6f906df3b52e10508/56x56-000000-80-0-0.jpg",
                    "cover_medium": "https://cdns-images.dzcdn.net/images/cover/bf45f20545c62de6f906df3b52e10508/250x250-000000-80-0-0.jpg",
                    "cover_big": "https://cdns-images.dzcdn.net/images/cover/bf45f20545c62de6f906df3b52e10508/500x500-000000-80-0-0.jpg",
                    "cover_xl": "https://cdns-images.dzcdn.net/images/cover/bf45f20545c62de6f906df3b52e10508/1000x1000-000000-80-0-0.jpg",
                    "md5_image": "bf45f20545c62de6f906df3b52e10508",
                    "tracklist": "https://api.deezer.com/album/177475252/tracks",
                    "type": "album"
                },
                "type": "track"
            },
            {
                "id": 1324315212,
                "readable": true,
                "title": "Ronna Hi Si",
                "title_short": "Ronna Hi Si",
                "title_version": "",
                "link": "https://www.deezer.com/track/1324315212",
                "duration": 268,
                "rank": 101922,
                "explicit_lyrics": false,
                "explicit_content_lyrics": 0,
                "explicit_content_cover": 2,
                "preview": "https://cdns-preview-7.dzcdn.net/stream/c-70e52d64c9e866ae9ec328c2bf0a1191-2.mp3",
                "md5_image": "effdb8e0b60a1b696d30db05c0795f0d",
                "artist": {
                    "id": 5368678,
                    "name": "Ranjit Bawa",
                    "link": "https://www.deezer.com/artist/5368678",
                    "picture": "https://api.deezer.com/artist/5368678/image",
                    "picture_small": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/56x56-000000-80-0-0.jpg",
                    "picture_medium": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/250x250-000000-80-0-0.jpg",
                    "picture_big": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/500x500-000000-80-0-0.jpg",
                    "picture_xl": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/1000x1000-000000-80-0-0.jpg",
                    "tracklist": "https://api.deezer.com/artist/5368678/top?limit=50",
                    "type": "artist"
                },
                "album": {
                    "id": 220748782,
                    "title": "Ronna Hi Si",
                    "cover": "https://api.deezer.com/album/220748782/image",
                    "cover_small": "https://cdns-images.dzcdn.net/images/cover/effdb8e0b60a1b696d30db05c0795f0d/56x56-000000-80-0-0.jpg",
                    "cover_medium": "https://cdns-images.dzcdn.net/images/cover/effdb8e0b60a1b696d30db05c0795f0d/250x250-000000-80-0-0.jpg",
                    "cover_big": "https://cdns-images.dzcdn.net/images/cover/effdb8e0b60a1b696d30db05c0795f0d/500x500-000000-80-0-0.jpg",
                    "cover_xl": "https://cdns-images.dzcdn.net/images/cover/effdb8e0b60a1b696d30db05c0795f0d/1000x1000-000000-80-0-0.jpg",
                    "md5_image": "effdb8e0b60a1b696d30db05c0795f0d",
                    "tracklist": "https://api.deezer.com/album/220748782/tracks",
                    "type": "album"
                },
                "type": "track"
            },
            {
                "id": 534866212,
                "readable": true,
                "title": "Heavyweight Bhangra",
                "title_short": "Heavyweight Bhangra",
                "link": "https://www.deezer.com/track/534866212",
                "duration": 189,
                "rank": 134212,
                "explicit_lyrics": false,
                "explicit_content_lyrics": 0,
                "explicit_content_cover": 2,
                "preview": "https://cdns-preview-c.dzcdn.net/stream/c-c9740388e0ca2169d26297a3cbd17a8d-3.mp3",
                "md5_image": "aa4866f44fe2293c91a686660ad17388",
                "artist": {
                    "id": 5368678,
                    "name": "Ranjit Bawa",
                    "link": "https://www.deezer.com/artist/5368678",
                    "picture": "https://api.deezer.com/artist/5368678/image",
                    "picture_small": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/56x56-000000-80-0-0.jpg",
                    "picture_medium": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/250x250-000000-80-0-0.jpg",
                    "picture_big": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/500x500-000000-80-0-0.jpg",
                    "picture_xl": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/1000x1000-000000-80-0-0.jpg",
                    "tracklist": "https://api.deezer.com/artist/5368678/top?limit=50",
                    "type": "artist"
                },
                "album": {
                    "id": 69552862,
                    "title": "Heavy Weight Bhangra - Single",
                    "cover": "https://api.deezer.com/album/69552862/image",
                    "cover_small": "https://cdns-images.dzcdn.net/images/cover/aa4866f44fe2293c91a686660ad17388/56x56-000000-80-0-0.jpg",
                    "cover_medium": "https://cdns-images.dzcdn.net/images/cover/aa4866f44fe2293c91a686660ad17388/250x250-000000-80-0-0.jpg",
                    "cover_big": "https://cdns-images.dzcdn.net/images/cover/aa4866f44fe2293c91a686660ad17388/500x500-000000-80-0-0.jpg",
                    "cover_xl": "https://cdns-images.dzcdn.net/images/cover/aa4866f44fe2293c91a686660ad17388/1000x1000-000000-80-0-0.jpg",
                    "md5_image": "aa4866f44fe2293c91a686660ad17388",
                    "tracklist": "https://api.deezer.com/album/69552862/tracks",
                    "type": "album"
                },
                "type": "track"
            },
            {
                "id": 651802822,
                "readable": true,
                "title": "Tappe (From \"Rabb Da Radio 2\")",
                "title_short": "Tappe",
                "title_version": "(From \"Rabb Da Radio 2\")",
                "link": "https://www.deezer.com/track/651802822",
                "duration": 206,
                "rank": 107686,
                "explicit_lyrics": false,
                "explicit_content_lyrics": 0,
                "explicit_content_cover": 2,
                "preview": "https://cdns-preview-d.dzcdn.net/stream/c-da8d62a47dfa121bac83c16d0cf0540b-3.mp3",
                "md5_image": "dd15ea7ee9c54de2bfb67052b73abe76",
                "artist": {
                    "id": 5368678,
                    "name": "Ranjit Bawa",
                    "link": "https://www.deezer.com/artist/5368678",
                    "picture": "https://api.deezer.com/artist/5368678/image",
                    "picture_small": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/56x56-000000-80-0-0.jpg",
                    "picture_medium": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/250x250-000000-80-0-0.jpg",
                    "picture_big": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/500x500-000000-80-0-0.jpg",
                    "picture_xl": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/1000x1000-000000-80-0-0.jpg",
                    "tracklist": "https://api.deezer.com/artist/5368678/top?limit=50",
                    "type": "artist"
                },
                "album": {
                    "id": 90962602,
                    "title": "Tappe (From \"Rabb Da Radio 2\")",
                    "cover": "https://api.deezer.com/album/90962602/image",
                    "cover_small": "https://cdns-images.dzcdn.net/images/cover/dd15ea7ee9c54de2bfb67052b73abe76/56x56-000000-80-0-0.jpg",
                    "cover_medium": "https://cdns-images.dzcdn.net/images/cover/dd15ea7ee9c54de2bfb67052b73abe76/250x250-000000-80-0-0.jpg",
                    "cover_big": "https://cdns-images.dzcdn.net/images/cover/dd15ea7ee9c54de2bfb67052b73abe76/500x500-000000-80-0-0.jpg",
                    "cover_xl": "https://cdns-images.dzcdn.net/images/cover/dd15ea7ee9c54de2bfb67052b73abe76/1000x1000-000000-80-0-0.jpg",
                    "md5_image": "dd15ea7ee9c54de2bfb67052b73abe76",
                    "tracklist": "https://api.deezer.com/album/90962602/tracks",
                    "type": "album"
                },
                "type": "track"
            },
            {
                "id": 1041740052,
                "readable": true,
                "title": "Chote Chote Ghar",
                "title_short": "Chote Chote Ghar",
                "title_version": "",
                "link": "https://www.deezer.com/track/1041740052",
                "duration": 215,
                "rank": 220598,
                "explicit_lyrics": false,
                "explicit_content_lyrics": 0,
                "explicit_content_cover": 2,
                "preview": "https://cdns-preview-6.dzcdn.net/stream/c-6ca7bdf6ad053e22daaf663b7092e256-2.mp3",
                "md5_image": "2d2490e2bd461859178e31c3e7c8b18b",
                "artist": {
                    "id": 5368678,
                    "name": "Ranjit Bawa",
                    "link": "https://www.deezer.com/artist/5368678",
                    "picture": "https://api.deezer.com/artist/5368678/image",
                    "picture_small": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/56x56-000000-80-0-0.jpg",
                    "picture_medium": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/250x250-000000-80-0-0.jpg",
                    "picture_big": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/500x500-000000-80-0-0.jpg",
                    "picture_xl": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/1000x1000-000000-80-0-0.jpg",
                    "tracklist": "https://api.deezer.com/artist/5368678/top?limit=50",
                    "type": "artist"
                },
                "album": {
                    "id": 164962142,
                    "title": "Chote Chote Ghar",
                    "cover": "https://api.deezer.com/album/164962142/image",
                    "cover_small": "https://cdns-images.dzcdn.net/images/cover/2d2490e2bd461859178e31c3e7c8b18b/56x56-000000-80-0-0.jpg",
                    "cover_medium": "https://cdns-images.dzcdn.net/images/cover/2d2490e2bd461859178e31c3e7c8b18b/250x250-000000-80-0-0.jpg",
                    "cover_big": "https://cdns-images.dzcdn.net/images/cover/2d2490e2bd461859178e31c3e7c8b18b/500x500-000000-80-0-0.jpg",
                    "cover_xl": "https://cdns-images.dzcdn.net/images/cover/2d2490e2bd461859178e31c3e7c8b18b/1000x1000-000000-80-0-0.jpg",
                    "md5_image": "2d2490e2bd461859178e31c3e7c8b18b",
                    "tracklist": "https://api.deezer.com/album/164962142/tracks",
                    "type": "album"
                },
                "type": "track"
            },
            {
                "id": 556352672,
                "readable": true,
                "title": "Sun Sohniye (From \"Afsar\")",
                "title_short": "Sun Sohniye",
                "title_version": "(From \"Afsar\")",
                "link": "https://www.deezer.com/track/556352672",
                "duration": 158,
                "rank": 116050,
                "explicit_lyrics": false,
                "explicit_content_lyrics": 0,
                "explicit_content_cover": 2,
                "preview": "https://cdns-preview-b.dzcdn.net/stream/c-b7dce2e83744e10e1e8a3422948f4a98-3.mp3",
                "md5_image": "b40e5c8674e425508a02c55de5ad22e2",
                "artist": {
                    "id": 5368678,
                    "name": "Ranjit Bawa",
                    "link": "https://www.deezer.com/artist/5368678",
                    "picture": "https://api.deezer.com/artist/5368678/image",
                    "picture_small": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/56x56-000000-80-0-0.jpg",
                    "picture_medium": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/250x250-000000-80-0-0.jpg",
                    "picture_big": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/500x500-000000-80-0-0.jpg",
                    "picture_xl": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/1000x1000-000000-80-0-0.jpg",
                    "tracklist": "https://api.deezer.com/artist/5368678/top?limit=50",
                    "type": "artist"
                },
                "album": {
                    "id": 73444922,
                    "title": "Sun Sohniye (From \"Afsar\")",
                    "cover": "https://api.deezer.com/album/73444922/image",
                    "cover_small": "https://cdns-images.dzcdn.net/images/cover/b40e5c8674e425508a02c55de5ad22e2/56x56-000000-80-0-0.jpg",
                    "cover_medium": "https://cdns-images.dzcdn.net/images/cover/b40e5c8674e425508a02c55de5ad22e2/250x250-000000-80-0-0.jpg",
                    "cover_big": "https://cdns-images.dzcdn.net/images/cover/b40e5c8674e425508a02c55de5ad22e2/500x500-000000-80-0-0.jpg",
                    "cover_xl": "https://cdns-images.dzcdn.net/images/cover/b40e5c8674e425508a02c55de5ad22e2/1000x1000-000000-80-0-0.jpg",
                    "md5_image": "b40e5c8674e425508a02c55de5ad22e2",
                    "tracklist": "https://api.deezer.com/album/73444922/tracks",
                    "type": "album"
                },
                "type": "track"
            },
            {
                "id": 1290059162,
                "readable": true,
                "title": "Koka",
                "title_short": "Koka",
                "title_version": "",
                "link": "https://www.deezer.com/track/1290059162",
                "duration": 190,
                "rank": 199079,
                "explicit_lyrics": false,
                "explicit_content_lyrics": 0,
                "explicit_content_cover": 2,
                "preview": "https://cdns-preview-f.dzcdn.net/stream/c-f492dc9e77a8b41cb65bf65d7ac2867e-2.mp3",
                "md5_image": "d699b6cdee0ab88adf0a1e1e649726a8",
                "artist": {
                    "id": 5368678,
                    "name": "Ranjit Bawa",
                    "link": "https://www.deezer.com/artist/5368678",
                    "picture": "https://api.deezer.com/artist/5368678/image",
                    "picture_small": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/56x56-000000-80-0-0.jpg",
                    "picture_medium": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/250x250-000000-80-0-0.jpg",
                    "picture_big": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/500x500-000000-80-0-0.jpg",
                    "picture_xl": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/1000x1000-000000-80-0-0.jpg",
                    "tracklist": "https://api.deezer.com/artist/5368678/top?limit=50",
                    "type": "artist"
                },
                "album": {
                    "id": 218263812,
                    "title": "Koka",
                    "cover": "https://api.deezer.com/album/218263812/image",
                    "cover_small": "https://cdns-images.dzcdn.net/images/cover/d699b6cdee0ab88adf0a1e1e649726a8/56x56-000000-80-0-0.jpg",
                    "cover_medium": "https://cdns-images.dzcdn.net/images/cover/d699b6cdee0ab88adf0a1e1e649726a8/250x250-000000-80-0-0.jpg",
                    "cover_big": "https://cdns-images.dzcdn.net/images/cover/d699b6cdee0ab88adf0a1e1e649726a8/500x500-000000-80-0-0.jpg",
                    "cover_xl": "https://cdns-images.dzcdn.net/images/cover/d699b6cdee0ab88adf0a1e1e649726a8/1000x1000-000000-80-0-0.jpg",
                    "md5_image": "d699b6cdee0ab88adf0a1e1e649726a8",
                    "tracklist": "https://api.deezer.com/album/218263812/tracks",
                    "type": "album"
                },
                "type": "track"
            },
            {
                "id": 1211358392,
                "readable": true,
                "title": "21 Vi Sdi",
                "title_short": "21 Vi Sdi",
                "title_version": "",
                "link": "https://www.deezer.com/track/1211358392",
                "duration": 353,
                "rank": 94375,
                "explicit_lyrics": false,
                "explicit_content_lyrics": 0,
                "explicit_content_cover": 2,
                "preview": "https://cdns-preview-1.dzcdn.net/stream/c-10de0445e3f32451ad4bb284b0dcf4d9-2.mp3",
                "md5_image": "6b55aebfbc3f8c0830976a8af15a20e2",
                "artist": {
                    "id": 5368678,
                    "name": "Ranjit Bawa",
                    "link": "https://www.deezer.com/artist/5368678",
                    "picture": "https://api.deezer.com/artist/5368678/image",
                    "picture_small": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/56x56-000000-80-0-0.jpg",
                    "picture_medium": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/250x250-000000-80-0-0.jpg",
                    "picture_big": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/500x500-000000-80-0-0.jpg",
                    "picture_xl": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/1000x1000-000000-80-0-0.jpg",
                    "tracklist": "https://api.deezer.com/artist/5368678/top?limit=50",
                    "type": "artist"
                },
                "album": {
                    "id": 200514862,
                    "title": "21 Vi Sdi",
                    "cover": "https://api.deezer.com/album/200514862/image",
                    "cover_small": "https://cdns-images.dzcdn.net/images/cover/6b55aebfbc3f8c0830976a8af15a20e2/56x56-000000-80-0-0.jpg",
                    "cover_medium": "https://cdns-images.dzcdn.net/images/cover/6b55aebfbc3f8c0830976a8af15a20e2/250x250-000000-80-0-0.jpg",
                    "cover_big": "https://cdns-images.dzcdn.net/images/cover/6b55aebfbc3f8c0830976a8af15a20e2/500x500-000000-80-0-0.jpg",
                    "cover_xl": "https://cdns-images.dzcdn.net/images/cover/6b55aebfbc3f8c0830976a8af15a20e2/1000x1000-000000-80-0-0.jpg",
                    "md5_image": "6b55aebfbc3f8c0830976a8af15a20e2",
                    "tracklist": "https://api.deezer.com/album/200514862/tracks",
                    "type": "album"
                },
                "type": "track"
            },
            {
                "id": 854450442,
                "readable": true,
                "title": "Like Karan",
                "title_short": "Like Karan",
                "title_version": "",
                "link": "https://www.deezer.com/track/854450442",
                "duration": 207,
                "rank": 91856,
                "explicit_lyrics": false,
                "explicit_content_lyrics": 0,
                "explicit_content_cover": 2,
                "preview": "https://cdns-preview-8.dzcdn.net/stream/c-83a75558fd7a9998b1682ed7d444c688-2.mp3",
                "md5_image": "3dd663265d266c78f67b899d51d319a0",
                "artist": {
                    "id": 5368678,
                    "name": "Ranjit Bawa",
                    "link": "https://www.deezer.com/artist/5368678",
                    "picture": "https://api.deezer.com/artist/5368678/image",
                    "picture_small": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/56x56-000000-80-0-0.jpg",
                    "picture_medium": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/250x250-000000-80-0-0.jpg",
                    "picture_big": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/500x500-000000-80-0-0.jpg",
                    "picture_xl": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/1000x1000-000000-80-0-0.jpg",
                    "tracklist": "https://api.deezer.com/artist/5368678/top?limit=50",
                    "type": "artist"
                },
                "album": {
                    "id": 127156522,
                    "title": "Khatre da Ghuggu (Original Motion Pictures Soundtrack)",
                    "cover": "https://api.deezer.com/album/127156522/image",
                    "cover_small": "https://cdns-images.dzcdn.net/images/cover/3dd663265d266c78f67b899d51d319a0/56x56-000000-80-0-0.jpg",
                    "cover_medium": "https://cdns-images.dzcdn.net/images/cover/3dd663265d266c78f67b899d51d319a0/250x250-000000-80-0-0.jpg",
                    "cover_big": "https://cdns-images.dzcdn.net/images/cover/3dd663265d266c78f67b899d51d319a0/500x500-000000-80-0-0.jpg",
                    "cover_xl": "https://cdns-images.dzcdn.net/images/cover/3dd663265d266c78f67b899d51d319a0/1000x1000-000000-80-0-0.jpg",
                    "md5_image": "3dd663265d266c78f67b899d51d319a0",
                    "tracklist": "https://api.deezer.com/album/127156522/tracks",
                    "type": "album"
                },
                "type": "track"
            },
            {
                "id": 1190865262,
                "readable": true,
                "title": "Fateh Aa",
                "title_short": "Fateh Aa",
                "title_version": "",
                "link": "https://www.deezer.com/track/1190865262",
                "duration": 276,
                "rank": 87206,
                "explicit_lyrics": false,
                "explicit_content_lyrics": 0,
                "explicit_content_cover": 2,
                "preview": "https://cdns-preview-3.dzcdn.net/stream/c-3da5b1bb5bf30c01bcb44da580242ba0-3.mp3",
                "md5_image": "9b1d793cb65912b077e473b1eb23de62",
                "artist": {
                    "id": 5368678,
                    "name": "Ranjit Bawa",
                    "link": "https://www.deezer.com/artist/5368678",
                    "picture": "https://api.deezer.com/artist/5368678/image",
                    "picture_small": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/56x56-000000-80-0-0.jpg",
                    "picture_medium": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/250x250-000000-80-0-0.jpg",
                    "picture_big": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/500x500-000000-80-0-0.jpg",
                    "picture_xl": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/1000x1000-000000-80-0-0.jpg",
                    "tracklist": "https://api.deezer.com/artist/5368678/top?limit=50",
                    "type": "artist"
                },
                "album": {
                    "id": 196078602,
                    "title": "Fateh Aa",
                    "cover": "https://api.deezer.com/album/196078602/image",
                    "cover_small": "https://cdns-images.dzcdn.net/images/cover/9b1d793cb65912b077e473b1eb23de62/56x56-000000-80-0-0.jpg",
                    "cover_medium": "https://cdns-images.dzcdn.net/images/cover/9b1d793cb65912b077e473b1eb23de62/250x250-000000-80-0-0.jpg",
                    "cover_big": "https://cdns-images.dzcdn.net/images/cover/9b1d793cb65912b077e473b1eb23de62/500x500-000000-80-0-0.jpg",
                    "cover_xl": "https://cdns-images.dzcdn.net/images/cover/9b1d793cb65912b077e473b1eb23de62/1000x1000-000000-80-0-0.jpg",
                    "md5_image": "9b1d793cb65912b077e473b1eb23de62",
                    "tracklist": "https://api.deezer.com/album/196078602/tracks",
                    "type": "album"
                },
                "type": "track"
            },
            {
                "id": 632764742,
                "readable": true,
                "title": "Badami Rangiye",
                "title_short": "Badami Rangiye",
                "title_version": "",
                "link": "https://www.deezer.com/track/632764742",
                "duration": 240,
                "rank": 41286,
                "explicit_lyrics": false,
                "explicit_content_lyrics": 0,
                "explicit_content_cover": 2,
                "preview": "https://cdns-preview-b.dzcdn.net/stream/c-b0088d9efb3136787cd0ab0211cd09b6-3.mp3",
                "md5_image": "3e32f116da79ea6ea7d105fa2d1879a3",
                "artist": {
                    "id": 5368678,
                    "name": "Ranjit Bawa",
                    "link": "https://www.deezer.com/artist/5368678",
                    "picture": "https://api.deezer.com/artist/5368678/image",
                    "picture_small": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/56x56-000000-80-0-0.jpg",
                    "picture_medium": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/250x250-000000-80-0-0.jpg",
                    "picture_big": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/500x500-000000-80-0-0.jpg",
                    "picture_xl": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/1000x1000-000000-80-0-0.jpg",
                    "tracklist": "https://api.deezer.com/artist/5368678/top?limit=50",
                    "type": "artist"
                },
                "album": {
                    "id": 87350372,
                    "title": "Badami Rangiye",
                    "cover": "https://api.deezer.com/album/87350372/image",
                    "cover_small": "https://cdns-images.dzcdn.net/images/cover/3e32f116da79ea6ea7d105fa2d1879a3/56x56-000000-80-0-0.jpg",
                    "cover_medium": "https://cdns-images.dzcdn.net/images/cover/3e32f116da79ea6ea7d105fa2d1879a3/250x250-000000-80-0-0.jpg",
                    "cover_big": "https://cdns-images.dzcdn.net/images/cover/3e32f116da79ea6ea7d105fa2d1879a3/500x500-000000-80-0-0.jpg",
                    "cover_xl": "https://cdns-images.dzcdn.net/images/cover/3e32f116da79ea6ea7d105fa2d1879a3/1000x1000-000000-80-0-0.jpg",
                    "md5_image": "3e32f116da79ea6ea7d105fa2d1879a3",
                    "tracklist": "https://api.deezer.com/album/87350372/tracks",
                    "type": "album"
                },
                "type": "track"
            },
            {
                "id": 535656752,
                "readable": true,
                "title": "Baabu Ji",
                "title_short": "Baabu Ji",
                "title_version": "",
                "link": "https://www.deezer.com/track/535656752",
                "duration": 185,
                "rank": 55498,
                "explicit_lyrics": false,
                "explicit_content_lyrics": 0,
                "explicit_content_cover": 2,
                "preview": "https://cdns-preview-8.dzcdn.net/stream/c-8648e318d5153b74fab212c6a5922ce3-3.mp3",
                "md5_image": "8c380ecf28472b83b84a9bdc71256db3",
                "artist": {
                    "id": 5368678,
                    "name": "Ranjit Bawa",
                    "link": "https://www.deezer.com/artist/5368678",
                    "picture": "https://api.deezer.com/artist/5368678/image",
                    "picture_small": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/56x56-000000-80-0-0.jpg",
                    "picture_medium": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/250x250-000000-80-0-0.jpg",
                    "picture_big": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/500x500-000000-80-0-0.jpg",
                    "picture_xl": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/1000x1000-000000-80-0-0.jpg",
                    "tracklist": "https://api.deezer.com/artist/5368678/top?limit=50",
                    "type": "artist"
                },
                "album": {
                    "id": 69682292,
                    "title": "Baabu Ji - Single",
                    "cover": "https://api.deezer.com/album/69682292/image",
                    "cover_small": "https://cdns-images.dzcdn.net/images/cover/8c380ecf28472b83b84a9bdc71256db3/56x56-000000-80-0-0.jpg",
                    "cover_medium": "https://cdns-images.dzcdn.net/images/cover/8c380ecf28472b83b84a9bdc71256db3/250x250-000000-80-0-0.jpg",
                    "cover_big": "https://cdns-images.dzcdn.net/images/cover/8c380ecf28472b83b84a9bdc71256db3/500x500-000000-80-0-0.jpg",
                    "cover_xl": "https://cdns-images.dzcdn.net/images/cover/8c380ecf28472b83b84a9bdc71256db3/1000x1000-000000-80-0-0.jpg",
                    "md5_image": "8c380ecf28472b83b84a9bdc71256db3",
                    "tracklist": "https://api.deezer.com/album/69682292/tracks",
                    "type": "album"
                },
                "type": "track"
            },
            {
                "id": 86106943,
                "readable": true,
                "title": "Narrow Salwar",
                "title_short": "Narrow Salwar",
                "title_version": "",
                "link": "https://www.deezer.com/track/86106943",
                "duration": 318,
                "rank": 64251,
                "explicit_lyrics": false,
                "explicit_content_lyrics": 0,
                "explicit_content_cover": 2,
                "preview": "https://cdns-preview-e.dzcdn.net/stream/c-e154bcbb04329f4f0abb3155a976f414-2.mp3",
                "md5_image": "0e59961340086c08d5eac7c6ac00d16e",
                "artist": {
                    "id": 5368678,
                    "name": "Ranjit Bawa",
                    "link": "https://www.deezer.com/artist/5368678",
                    "picture": "https://api.deezer.com/artist/5368678/image",
                    "picture_small": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/56x56-000000-80-0-0.jpg",
                    "picture_medium": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/250x250-000000-80-0-0.jpg",
                    "picture_big": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/500x500-000000-80-0-0.jpg",
                    "picture_xl": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/1000x1000-000000-80-0-0.jpg",
                    "tracklist": "https://api.deezer.com/artist/5368678/top?limit=50",
                    "type": "artist"
                },
                "album": {
                    "id": 8684805,
                    "title": "Best Punjabi Bhangra Songs, Vol.1",
                    "cover": "https://api.deezer.com/album/8684805/image",
                    "cover_small": "https://cdns-images.dzcdn.net/images/cover/0e59961340086c08d5eac7c6ac00d16e/56x56-000000-80-0-0.jpg",
                    "cover_medium": "https://cdns-images.dzcdn.net/images/cover/0e59961340086c08d5eac7c6ac00d16e/250x250-000000-80-0-0.jpg",
                    "cover_big": "https://cdns-images.dzcdn.net/images/cover/0e59961340086c08d5eac7c6ac00d16e/500x500-000000-80-0-0.jpg",
                    "cover_xl": "https://cdns-images.dzcdn.net/images/cover/0e59961340086c08d5eac7c6ac00d16e/1000x1000-000000-80-0-0.jpg",
                    "md5_image": "0e59961340086c08d5eac7c6ac00d16e",
                    "tracklist": "https://api.deezer.com/album/8684805/tracks",
                    "type": "album"
                },
                "type": "track"
            },
            {
                "id": 858312132,
                "readable": true,
                "title": "Approach",
                "title_short": "Approach",
                "title_version": "",
                "link": "https://www.deezer.com/track/858312132",
                "duration": 238,
                "rank": 55631,
                "explicit_lyrics": false,
                "explicit_content_lyrics": 0,
                "explicit_content_cover": 2,
                "preview": "https://cdns-preview-3.dzcdn.net/stream/c-30a6f405f59dd92c5c10e677e3fbecb0-2.mp3",
                "md5_image": "451914e3344a8782adc44df0c655d55d",
                "artist": {
                    "id": 5368678,
                    "name": "Ranjit Bawa",
                    "link": "https://www.deezer.com/artist/5368678",
                    "picture": "https://api.deezer.com/artist/5368678/image",
                    "picture_small": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/56x56-000000-80-0-0.jpg",
                    "picture_medium": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/250x250-000000-80-0-0.jpg",
                    "picture_big": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/500x500-000000-80-0-0.jpg",
                    "picture_xl": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/1000x1000-000000-80-0-0.jpg",
                    "tracklist": "https://api.deezer.com/artist/5368678/top?limit=50",
                    "type": "artist"
                },
                "album": {
                    "id": 128017142,
                    "title": "Approach",
                    "cover": "https://api.deezer.com/album/128017142/image",
                    "cover_small": "https://cdns-images.dzcdn.net/images/cover/451914e3344a8782adc44df0c655d55d/56x56-000000-80-0-0.jpg",
                    "cover_medium": "https://cdns-images.dzcdn.net/images/cover/451914e3344a8782adc44df0c655d55d/250x250-000000-80-0-0.jpg",
                    "cover_big": "https://cdns-images.dzcdn.net/images/cover/451914e3344a8782adc44df0c655d55d/500x500-000000-80-0-0.jpg",
                    "cover_xl": "https://cdns-images.dzcdn.net/images/cover/451914e3344a8782adc44df0c655d55d/1000x1000-000000-80-0-0.jpg",
                    "md5_image": "451914e3344a8782adc44df0c655d55d",
                    "tracklist": "https://api.deezer.com/album/128017142/tracks",
                    "type": "album"
                },
                "type": "track"
            },
            {
                "id": 1227288762,
                "readable": true,
                "title": "Phulkari",
                "title_short": "Phulkari",
                "title_version": "",
                "link": "https://www.deezer.com/track/1227288762",
                "duration": 244,
                "rank": 109823,
                "explicit_lyrics": false,
                "explicit_content_lyrics": 0,
                "explicit_content_cover": 0,
                "preview": "https://cdns-preview-5.dzcdn.net/stream/c-52fe0044b57fee703b61ef8fef5245d6-3.mp3",
                "md5_image": "00f11fc4f1de693c426078ff4ae934ff",
                "artist": {
                    "id": 5368678,
                    "name": "Ranjit Bawa",
                    "link": "https://www.deezer.com/artist/5368678",
                    "picture": "https://api.deezer.com/artist/5368678/image",
                    "picture_small": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/56x56-000000-80-0-0.jpg",
                    "picture_medium": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/250x250-000000-80-0-0.jpg",
                    "picture_big": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/500x500-000000-80-0-0.jpg",
                    "picture_xl": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/1000x1000-000000-80-0-0.jpg",
                    "tracklist": "https://api.deezer.com/artist/5368678/top?limit=50",
                    "type": "artist"
                },
                "album": {
                    "id": 204006192,
                    "title": "Phulkari",
                    "cover": "https://api.deezer.com/album/204006192/image",
                    "cover_small": "https://cdns-images.dzcdn.net/images/cover/00f11fc4f1de693c426078ff4ae934ff/56x56-000000-80-0-0.jpg",
                    "cover_medium": "https://cdns-images.dzcdn.net/images/cover/00f11fc4f1de693c426078ff4ae934ff/250x250-000000-80-0-0.jpg",
                    "cover_big": "https://cdns-images.dzcdn.net/images/cover/00f11fc4f1de693c426078ff4ae934ff/500x500-000000-80-0-0.jpg",
                    "cover_xl": "https://cdns-images.dzcdn.net/images/cover/00f11fc4f1de693c426078ff4ae934ff/1000x1000-000000-80-0-0.jpg",
                    "md5_image": "00f11fc4f1de693c426078ff4ae934ff",
                    "tracklist": "https://api.deezer.com/album/204006192/tracks",
                    "type": "album"
                },
                "type": "track"
            },
            {
                "id": 951652542,
                "readable": true,
                "title": "Mera Ki Kasoor",
                "title_short": "Mera Ki Kasoor",
                "title_version": "",
                "link": "https://www.deezer.com/track/951652542",
                "duration": 263,
                "rank": 61638,
                "explicit_lyrics": false,
                "explicit_content_lyrics": 0,
                "explicit_content_cover": 2,
                "preview": "https://cdns-preview-c.dzcdn.net/stream/c-c1e2daae0335b31bc8636a1cded78e46-3.mp3",
                "md5_image": "530ab1e8d3c1214be12fdf084cfbe073",
                "artist": {
                    "id": 5368678,
                    "name": "Ranjit Bawa",
                    "link": "https://www.deezer.com/artist/5368678",
                    "picture": "https://api.deezer.com/artist/5368678/image",
                    "picture_small": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/56x56-000000-80-0-0.jpg",
                    "picture_medium": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/250x250-000000-80-0-0.jpg",
                    "picture_big": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/500x500-000000-80-0-0.jpg",
                    "picture_xl": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/1000x1000-000000-80-0-0.jpg",
                    "tracklist": "https://api.deezer.com/artist/5368678/top?limit=50",
                    "type": "artist"
                },
                "album": {
                    "id": 146438022,
                    "title": "Mera Ki Kasoor",
                    "cover": "https://api.deezer.com/album/146438022/image",
                    "cover_small": "https://cdns-images.dzcdn.net/images/cover/530ab1e8d3c1214be12fdf084cfbe073/56x56-000000-80-0-0.jpg",
                    "cover_medium": "https://cdns-images.dzcdn.net/images/cover/530ab1e8d3c1214be12fdf084cfbe073/250x250-000000-80-0-0.jpg",
                    "cover_big": "https://cdns-images.dzcdn.net/images/cover/530ab1e8d3c1214be12fdf084cfbe073/500x500-000000-80-0-0.jpg",
                    "cover_xl": "https://cdns-images.dzcdn.net/images/cover/530ab1e8d3c1214be12fdf084cfbe073/1000x1000-000000-80-0-0.jpg",
                    "md5_image": "530ab1e8d3c1214be12fdf084cfbe073",
                    "tracklist": "https://api.deezer.com/album/146438022/tracks",
                    "type": "album"
                },
                "type": "track"
            },
            {
                "id": 1035646912,
                "readable": true,
                "title": "Chandigarh Wali",
                "title_short": "Chandigarh Wali",
                "title_version": "",
                "link": "https://www.deezer.com/track/1035646912",
                "duration": 230,
                "rank": 30428,
                "explicit_lyrics": false,
                "explicit_content_lyrics": 0,
                "explicit_content_cover": 2,
                "preview": "https://cdns-preview-4.dzcdn.net/stream/c-4ae63d7c6471f37fa200f61fda4afbeb-2.mp3",
                "md5_image": "e57adb9b64f33cb2daa14ee0ce8c82a3",
                "artist": {
                    "id": 5368678,
                    "name": "Ranjit Bawa",
                    "link": "https://www.deezer.com/artist/5368678",
                    "picture": "https://api.deezer.com/artist/5368678/image",
                    "picture_small": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/56x56-000000-80-0-0.jpg",
                    "picture_medium": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/250x250-000000-80-0-0.jpg",
                    "picture_big": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/500x500-000000-80-0-0.jpg",
                    "picture_xl": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/1000x1000-000000-80-0-0.jpg",
                    "tracklist": "https://api.deezer.com/artist/5368678/top?limit=50",
                    "type": "artist"
                },
                "album": {
                    "id": 163610512,
                    "title": "Chandigarh Wali",
                    "cover": "https://api.deezer.com/album/163610512/image",
                    "cover_small": "https://cdns-images.dzcdn.net/images/cover/e57adb9b64f33cb2daa14ee0ce8c82a3/56x56-000000-80-0-0.jpg",
                    "cover_medium": "https://cdns-images.dzcdn.net/images/cover/e57adb9b64f33cb2daa14ee0ce8c82a3/250x250-000000-80-0-0.jpg",
                    "cover_big": "https://cdns-images.dzcdn.net/images/cover/e57adb9b64f33cb2daa14ee0ce8c82a3/500x500-000000-80-0-0.jpg",
                    "cover_xl": "https://cdns-images.dzcdn.net/images/cover/e57adb9b64f33cb2daa14ee0ce8c82a3/1000x1000-000000-80-0-0.jpg",
                    "md5_image": "e57adb9b64f33cb2daa14ee0ce8c82a3",
                    "tracklist": "https://api.deezer.com/album/163610512/tracks",
                    "type": "album"
                },
                "type": "track"
            },
            {
                "id": 965573622,
                "readable": true,
                "title": "Manzil",
                "title_short": "Manzil",
                "title_version": "",
                "link": "https://www.deezer.com/track/965573622",
                "duration": 196,
                "rank": 69492,
                "explicit_lyrics": false,
                "explicit_content_lyrics": 0,
                "explicit_content_cover": 2,
                "preview": "https://cdns-preview-3.dzcdn.net/stream/c-35288db789e8ce6e768b71dfd831029a-2.mp3",
                "md5_image": "93fade56337a2637e686d5764c9696b7",
                "artist": {
                    "id": 5368678,
                    "name": "Ranjit Bawa",
                    "link": "https://www.deezer.com/artist/5368678",
                    "picture": "https://api.deezer.com/artist/5368678/image",
                    "picture_small": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/56x56-000000-80-0-0.jpg",
                    "picture_medium": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/250x250-000000-80-0-0.jpg",
                    "picture_big": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/500x500-000000-80-0-0.jpg",
                    "picture_xl": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/1000x1000-000000-80-0-0.jpg",
                    "tracklist": "https://api.deezer.com/artist/5368678/top?limit=50",
                    "type": "artist"
                },
                "album": {
                    "id": 149320262,
                    "title": "Manzil",
                    "cover": "https://api.deezer.com/album/149320262/image",
                    "cover_small": "https://cdns-images.dzcdn.net/images/cover/93fade56337a2637e686d5764c9696b7/56x56-000000-80-0-0.jpg",
                    "cover_medium": "https://cdns-images.dzcdn.net/images/cover/93fade56337a2637e686d5764c9696b7/250x250-000000-80-0-0.jpg",
                    "cover_big": "https://cdns-images.dzcdn.net/images/cover/93fade56337a2637e686d5764c9696b7/500x500-000000-80-0-0.jpg",
                    "cover_xl": "https://cdns-images.dzcdn.net/images/cover/93fade56337a2637e686d5764c9696b7/1000x1000-000000-80-0-0.jpg",
                    "md5_image": "93fade56337a2637e686d5764c9696b7",
                    "tracklist": "https://api.deezer.com/album/149320262/tracks",
                    "type": "album"
                },
                "type": "track"
            },
            {
                "id": 537044132,
                "readable": true,
                "title": "Kankan",
                "title_short": "Kankan",
                "title_version": "",
                "link": "https://www.deezer.com/track/537044132",
                "duration": 234,
                "rank": 22473,
                "explicit_lyrics": false,
                "explicit_content_lyrics": 0,
                "explicit_content_cover": 2,
                "preview": "https://cdns-preview-6.dzcdn.net/stream/c-67f015d54cb6c0815fc413ee20ed8546-3.mp3",
                "md5_image": "5ef2c47233bac7d23599708c1b82c2ec",
                "artist": {
                    "id": 5368678,
                    "name": "Ranjit Bawa",
                    "link": "https://www.deezer.com/artist/5368678",
                    "picture": "https://api.deezer.com/artist/5368678/image",
                    "picture_small": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/56x56-000000-80-0-0.jpg",
                    "picture_medium": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/250x250-000000-80-0-0.jpg",
                    "picture_big": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/500x500-000000-80-0-0.jpg",
                    "picture_xl": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/1000x1000-000000-80-0-0.jpg",
                    "tracklist": "https://api.deezer.com/artist/5368678/top?limit=50",
                    "type": "artist"
                },
                "album": {
                    "id": 69921822,
                    "title": "Kankan - Single",
                    "cover": "https://api.deezer.com/album/69921822/image",
                    "cover_small": "https://cdns-images.dzcdn.net/images/cover/5ef2c47233bac7d23599708c1b82c2ec/56x56-000000-80-0-0.jpg",
                    "cover_medium": "https://cdns-images.dzcdn.net/images/cover/5ef2c47233bac7d23599708c1b82c2ec/250x250-000000-80-0-0.jpg",
                    "cover_big": "https://cdns-images.dzcdn.net/images/cover/5ef2c47233bac7d23599708c1b82c2ec/500x500-000000-80-0-0.jpg",
                    "cover_xl": "https://cdns-images.dzcdn.net/images/cover/5ef2c47233bac7d23599708c1b82c2ec/1000x1000-000000-80-0-0.jpg",
                    "md5_image": "5ef2c47233bac7d23599708c1b82c2ec",
                    "tracklist": "https://api.deezer.com/album/69921822/tracks",
                    "type": "album"
                },
                "type": "track"
            },
            {
                "id": 615348662,
                "readable": true,
                "title": "Gurpurab",
                "title_short": "Gurpurab",
                "title_version": "",
                "link": "https://www.deezer.com/track/615348662",
                "duration": 298,
                "rank": 54803,
                "explicit_lyrics": false,
                "explicit_content_lyrics": 0,
                "explicit_content_cover": 2,
                "preview": "https://cdns-preview-e.dzcdn.net/stream/c-e79c9139665423d0dc7650c72d254ea1-2.mp3",
                "md5_image": "d90346f54ee49a1ca07dc6b3c248f50b",
                "artist": {
                    "id": 5368678,
                    "name": "Ranjit Bawa",
                    "link": "https://www.deezer.com/artist/5368678",
                    "picture": "https://api.deezer.com/artist/5368678/image",
                    "picture_small": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/56x56-000000-80-0-0.jpg",
                    "picture_medium": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/250x250-000000-80-0-0.jpg",
                    "picture_big": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/500x500-000000-80-0-0.jpg",
                    "picture_xl": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/1000x1000-000000-80-0-0.jpg",
                    "tracklist": "https://api.deezer.com/artist/5368678/top?limit=50",
                    "type": "artist"
                },
                "album": {
                    "id": 83924492,
                    "title": "Gurpurab",
                    "cover": "https://api.deezer.com/album/83924492/image",
                    "cover_small": "https://cdns-images.dzcdn.net/images/cover/d90346f54ee49a1ca07dc6b3c248f50b/56x56-000000-80-0-0.jpg",
                    "cover_medium": "https://cdns-images.dzcdn.net/images/cover/d90346f54ee49a1ca07dc6b3c248f50b/250x250-000000-80-0-0.jpg",
                    "cover_big": "https://cdns-images.dzcdn.net/images/cover/d90346f54ee49a1ca07dc6b3c248f50b/500x500-000000-80-0-0.jpg",
                    "cover_xl": "https://cdns-images.dzcdn.net/images/cover/d90346f54ee49a1ca07dc6b3c248f50b/1000x1000-000000-80-0-0.jpg",
                    "md5_image": "d90346f54ee49a1ca07dc6b3c248f50b",
                    "tracklist": "https://api.deezer.com/album/83924492/tracks",
                    "type": "album"
                },
                "type": "track"
            },
            {
                "id": 1057134252,
                "readable": true,
                "title": "Banned",
                "title_short": "Banned",
                "title_version": "",
                "link": "https://www.deezer.com/track/1057134252",
                "duration": 234,
                "rank": 20936,
                "explicit_lyrics": false,
                "explicit_content_lyrics": 0,
                "explicit_content_cover": 2,
                "preview": "https://cdns-preview-f.dzcdn.net/stream/c-f3d8962935d705d3da12480eb19a5200-2.mp3",
                "md5_image": "61c45e4aa8eb0d78af062852e97b5b7d",
                "artist": {
                    "id": 5368678,
                    "name": "Ranjit Bawa",
                    "link": "https://www.deezer.com/artist/5368678",
                    "picture": "https://api.deezer.com/artist/5368678/image",
                    "picture_small": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/56x56-000000-80-0-0.jpg",
                    "picture_medium": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/250x250-000000-80-0-0.jpg",
                    "picture_big": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/500x500-000000-80-0-0.jpg",
                    "picture_xl": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/1000x1000-000000-80-0-0.jpg",
                    "tracklist": "https://api.deezer.com/artist/5368678/top?limit=50",
                    "type": "artist"
                },
                "album": {
                    "id": 168543162,
                    "title": "Banned",
                    "cover": "https://api.deezer.com/album/168543162/image",
                    "cover_small": "https://cdns-images.dzcdn.net/images/cover/61c45e4aa8eb0d78af062852e97b5b7d/56x56-000000-80-0-0.jpg",
                    "cover_medium": "https://cdns-images.dzcdn.net/images/cover/61c45e4aa8eb0d78af062852e97b5b7d/250x250-000000-80-0-0.jpg",
                    "cover_big": "https://cdns-images.dzcdn.net/images/cover/61c45e4aa8eb0d78af062852e97b5b7d/500x500-000000-80-0-0.jpg",
                    "cover_xl": "https://cdns-images.dzcdn.net/images/cover/61c45e4aa8eb0d78af062852e97b5b7d/1000x1000-000000-80-0-0.jpg",
                    "md5_image": "61c45e4aa8eb0d78af062852e97b5b7d",
                    "tracklist": "https://api.deezer.com/album/168543162/tracks",
                    "type": "album"
                },
                "type": "track"
            },
            {
                "id": 842007612,
                "readable": true,
                "title": "End Yaariyaan (From \"High End Yaariyaan\")",
                "title_short": "End Yaariyaan (From \"High End Yaariyaan\")",
                "title_version": "",
                "link": "https://www.deezer.com/track/842007612",
                "duration": 158,
                "rank": 54939,
                "explicit_lyrics": false,
                "explicit_content_lyrics": 0,
                "explicit_content_cover": 2,
                "preview": "https://cdns-preview-9.dzcdn.net/stream/c-957ac407a9798dcaa0270e61b2c7ea5b-2.mp3",
                "md5_image": "0afce099a6557fc104a64d9f496d065b",
                "artist": {
                    "id": 5368676,
                    "name": "Muzical Doctorz",
                    "link": "https://www.deezer.com/artist/5368676",
                    "picture": "https://api.deezer.com/artist/5368676/image",
                    "picture_small": "https://cdns-images.dzcdn.net/images/artist/d9aaddb66299d54b0c537e823359ac07/56x56-000000-80-0-0.jpg",
                    "picture_medium": "https://cdns-images.dzcdn.net/images/artist/d9aaddb66299d54b0c537e823359ac07/250x250-000000-80-0-0.jpg",
                    "picture_big": "https://cdns-images.dzcdn.net/images/artist/d9aaddb66299d54b0c537e823359ac07/500x500-000000-80-0-0.jpg",
                    "picture_xl": "https://cdns-images.dzcdn.net/images/artist/d9aaddb66299d54b0c537e823359ac07/1000x1000-000000-80-0-0.jpg",
                    "tracklist": "https://api.deezer.com/artist/5368676/top?limit=50",
                    "type": "artist"
                },
                "album": {
                    "id": 124391072,
                    "title": "Best of 2019 - Top Punjabi Streamed Hits",
                    "cover": "https://api.deezer.com/album/124391072/image",
                    "cover_small": "https://cdns-images.dzcdn.net/images/cover/0afce099a6557fc104a64d9f496d065b/56x56-000000-80-0-0.jpg",
                    "cover_medium": "https://cdns-images.dzcdn.net/images/cover/0afce099a6557fc104a64d9f496d065b/250x250-000000-80-0-0.jpg",
                    "cover_big": "https://cdns-images.dzcdn.net/images/cover/0afce099a6557fc104a64d9f496d065b/500x500-000000-80-0-0.jpg",
                    "cover_xl": "https://cdns-images.dzcdn.net/images/cover/0afce099a6557fc104a64d9f496d065b/1000x1000-000000-80-0-0.jpg",
                    "md5_image": "0afce099a6557fc104a64d9f496d065b",
                    "tracklist": "https://api.deezer.com/album/124391072/tracks",
                    "type": "album"
                },
                "type": "track"
            },
            {
                "id": 433142502,
                "readable": true,
                "title": "Muqabla",
                "title_short": "Muqabla",
                "title_version": "",
                "link": "https://www.deezer.com/track/433142502",
                "duration": 191,
                "rank": 37895,
                "explicit_lyrics": false,
                "explicit_content_lyrics": 0,
                "explicit_content_cover": 2,
                "preview": "https://cdns-preview-0.dzcdn.net/stream/c-0e0fb758162a05bfb420461ec9f0aa46-6.mp3",
                "md5_image": "8ee4b9d54524b3afad57c80035f7ea24",
                "artist": {
                    "id": 5368678,
                    "name": "Ranjit Bawa",
                    "link": "https://www.deezer.com/artist/5368678",
                    "picture": "https://api.deezer.com/artist/5368678/image",
                    "picture_small": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/56x56-000000-80-0-0.jpg",
                    "picture_medium": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/250x250-000000-80-0-0.jpg",
                    "picture_big": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/500x500-000000-80-0-0.jpg",
                    "picture_xl": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/1000x1000-000000-80-0-0.jpg",
                    "tracklist": "https://api.deezer.com/artist/5368678/top?limit=50",
                    "type": "artist"
                },
                "album": {
                    "id": 52281252,
                    "title": "Bailaras (Original Motion Picture Soundtrack)",
                    "cover": "https://api.deezer.com/album/52281252/image",
                    "cover_small": "https://cdns-images.dzcdn.net/images/cover/8ee4b9d54524b3afad57c80035f7ea24/56x56-000000-80-0-0.jpg",
                    "cover_medium": "https://cdns-images.dzcdn.net/images/cover/8ee4b9d54524b3afad57c80035f7ea24/250x250-000000-80-0-0.jpg",
                    "cover_big": "https://cdns-images.dzcdn.net/images/cover/8ee4b9d54524b3afad57c80035f7ea24/500x500-000000-80-0-0.jpg",
                    "cover_xl": "https://cdns-images.dzcdn.net/images/cover/8ee4b9d54524b3afad57c80035f7ea24/1000x1000-000000-80-0-0.jpg",
                    "md5_image": "8ee4b9d54524b3afad57c80035f7ea24",
                    "tracklist": "https://api.deezer.com/album/52281252/tracks",
                    "type": "album"
                },
                "type": "track"
            }
        
    ],
    song:{
        "id": 1169503732,
        "readable": true,
        "title": "Punjab Bolda",
        "title_short": "Punjab Bolda",
        "title_version": "",
        "link": "https://www.deezer.com/track/1169503732",
        "duration": 307,
        "rank": 188438,
        "explicit_lyrics": false,
        "explicit_content_lyrics": 0,
        "explicit_content_cover": 2,
        "preview": "https://cdns-preview-b.dzcdn.net/stream/c-b97797b8dc16071624a7df43d77785ef-2.mp3",
        "md5_image": "d59978e39d94332890c6fa7f1fa8966f",
        "artist": {
            "id": 5368678,
            "name": "Ranjit Bawa",
            "link": "https://www.deezer.com/artist/5368678",
            "picture": "https://api.deezer.com/artist/5368678/image",
            "picture_small": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/56x56-000000-80-0-0.jpg",
            "picture_medium": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/250x250-000000-80-0-0.jpg",
            "picture_big": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/500x500-000000-80-0-0.jpg",
            "picture_xl": "https://cdns-images.dzcdn.net/images/artist/5c2951a2e4c33598d194c575bbbbf381/1000x1000-000000-80-0-0.jpg",
            "tracklist": "https://api.deezer.com/artist/5368678/top?limit=50",
            "type": "artist"
        },
        "album": {
            "id": 191743462,
            "title": "Punjab Bolda",
            "cover": "https://api.deezer.com/album/191743462/image",
            "cover_small": "https://cdns-images.dzcdn.net/images/cover/d59978e39d94332890c6fa7f1fa8966f/56x56-000000-80-0-0.jpg",
            "cover_medium": "https://cdns-images.dzcdn.net/images/cover/d59978e39d94332890c6fa7f1fa8966f/250x250-000000-80-0-0.jpg",
            "cover_big": "https://cdns-images.dzcdn.net/images/cover/d59978e39d94332890c6fa7f1fa8966f/500x500-000000-80-0-0.jpg",
            "cover_xl": "https://cdns-images.dzcdn.net/images/cover/d59978e39d94332890c6fa7f1fa8966f/1000x1000-000000-80-0-0.jpg",
            "md5_image": "d59978e39d94332890c6fa7f1fa8966f",
            "tracklist": "https://api.deezer.com/album/191743462/tracks",
            "type": "album"
        },
        "type": "track"
    },
  }

  sendToPlayer = song=>{
    this.setState({
      song
    })
  }

  searchData = songs =>{
    this.setState({
        data:songs,
        song:songs[0]
      })
  }

  playNext=(currentSong,order)=>{

      for(let i=0;i<this.state.data.length;i++){
          if(this.state.data[i].id===currentSong.id){
            if(order==="next" && i<24){
                this.setState({
                    song:this.state.data[i+1]
                })
            }  
            else if(order==="prev" && i>0){
                this.setState({
                    song:this.state.data[i-1]
                })
            }
         }      
    
      }  
  }

  
  render(){

  return (
    <div className="App">
     <Header passSearchData={this.searchData}/>
     <main>
       <SongsList songs={this.state.data} sendToPlayer = {this.sendToPlayer}/> 
       <Player song={this.state.song} playnext={this.playNext}/>
     </main>
    </div>
  );
}
}
export default App;
